import { render, staticRenderFns } from "./DraftBox.vue?vue&type=template&id=662252fd&scoped=true"
import script from "./DraftBox.vue?vue&type=script&lang=js"
export * from "./DraftBox.vue?vue&type=script&lang=js"
import style0 from "./DraftBox.vue?vue&type=style&index=0&id=662252fd&prod&lang=scss"
import style1 from "./DraftBox.vue?vue&type=style&index=1&id=662252fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662252fd",
  null
  
)

export default component.exports